module.exports = __webpack_public_path__ + "img/hair_back_female_straight_short_mask.5047cc3a.png";